<template>
  <div>
    <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5"> </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <template v-if="!solicitacao.finalizada">
            <slide-x-left-transition :duration="200" mode="out-in" origin="center top">
              <form @submit.prevent>
                <card shadow type="secondary">
                  <h6 class="heading-small text-muted mb-1">
                    {{laboratorio.nomeFantasia}}
                  </h6>
                  <h6 class="heading-small text-muted mb-4">
                    Responsável Técnico: {{laboratorio.nomeResponsavel}} - CRO {{laboratorio.croResponsavel}}
                  </h6>
                  <flow-form :campos="campos">
                    <div slot="dente" class="column d-flex align-items-center">
                      <!--
                      <div class="agrupar column m-0 d-center text-center mb-4">
                        <base-checkbox v-model="agrupando" class="pr-0 mb-1">Agrupar?</base-checkbox>
                        <em class="text-muted text-size-sm animate-slide-right" v-if="!agrupando">Permite que você selecione vários dentes<br/>para um mesmo procedimento</em>
                        <em class="text-muted text-size-sm animate-slide-left" v-else>Agrupando sua seleção em um único procedimento<br/>Clique em aplicar grupo para finalizar</em>
                      </div>
                      -->
                      <div class="selecaoDente row justify-content-center position-relative">
                        <div class="msg position-absolute text-center animate-slide-up-center" v-if="msgGrupo" v-html="msgGrupo"></div>
                        <template v-for="(area, ai) in campos.dente.opcoesDentes">
                          <div
                            class="area row m-2"
                            :class="{ baixo: ai > 1 }"
                            :key="'area_dente_' + ai"
                          >
                            <span
                              class="dente d-center clickable"
                              :class="[{
                                selecionado: denteSelecionado(dente),
                              },denteAgrupado(dente)]"
                              @click="selecionarDente(dente)"
                              v-for="dente in area"
                              :key="'dente_' + dente"
                              >{{ dente }}</span
                            >
                          </div>
                          <div
                            class="break col-12"
                            :key="'justa_break' + ai"
                            v-if="ai == 1"
                          ></div>
                        </template>
                      </div>
                      <!-- v-if="agrupando" -->
                      <base-button type="default" class="align-self-center mt-4 d-flex animate-slide-up adddente" size="sm" @click="agruparDentes()">Adicionar</base-button>
                      <div class="dentesSelecionados mt-4">
                        <template v-for="(dente,didx) in campos.dente.value">
                          <template v-if="Array.isArray(dente)">
                            <div
                              class="denteSel mt-2"
                              :key="'dente_' + idGrupo(dente)"
                            >
                              <div class="nmDente py-3 row align-items-center justify-content-center mx-0" :class="{excluindo: dente[0].excluindo}">
                                <span class="remover d-center clickable" @click="excluirDente(dente,didx)">
                                  <span class="fas fa-times animate-slide-right" v-if="!dente[0].excluindo"></span>
                                  <span class="animate-slide-right" v-else>Clique para confirmar <span class="text-muted">{{dente[0].tempoExclusao}}</span></span>
                                </span>
                                <span title="Estes dentes estão agrupados" class="corGrupo" :class="denteAgrupado(dente[0].numero)"></span>
                                {{nomeGrupo(dente)}}
                              </div>
                              <flow-form :campos="dente[0]" />
                            </div>
                          </template>
                          <template v-else>
                            <div
                              class="denteSel mt-2"
                              :key="'dente_' + dente.numero"
                            >
                              <div class="nmDente py-3">Dente {{ dente.numero }}</div>
                              <flow-form :campos="dente" />
                            </div>
                          </template>
                        </template>

                      </div>
                    </div>
                  </flow-form>
                  
                  <div class="uploader">
                      <label>
                          <i class="ni ni-cloud-upload-96" />
                          <span>Selecionar Arquivos</span>
                          <input type="file" @change="processFiles" multiple />
                      </label>
                      <ul class="uploader-list">
                          <li v-for="(file, k) in filesArray" :key="k">{{file.name}}</li>
                      </ul>
                  </div>
                  
                  <div slot="footer" class="row p-2 justify-content-center">
                    <base-button
                      type="default"
                      @click="salvar()"
                      :class="{disabled: etapa == 1 && !cadastroValido}"
                      v-html="textoBotao"
                    ></base-button>
                  </div>
                  <template v-if="loading">
                      <div class="m-2">
                        <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                      </div>
                    </template>
                </card>
              </form>
            </slide-x-left-transition>
          </template>
          <template v-else>
            <!-- Solicitação finalizada -->
            <card shadow type="secondary">
              <h1>Solicitação de Serviço <span class="id">#{{solicitacao.idSolicitacao}}</span> enviada com sucesso!</h1>
              <div class="text">
                <p>Sua ordem de serviço foi enviada para o laboratório e aguarda aprovação. Assim que aprovada você será notificado(a).</p>
                 <p>Você será redirecionado...</p>
              </div>
            </card>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FlowForm from "@/components/cflow/FlowForm";
import formDemoOS from "@/forms/demoOS"
import helpers from "@/cflow/helpers";
import storage from "@/cflow/storageService";
import params from "@/cflow/parametros";
import { SlideXLeftTransition,SlideXRightTransition } from 'vue2-transitions';

var solicitarOrdem = {
  components: {
    FlowForm,
    SlideXLeftTransition,
    SlideXRightTransition
  },
  watch: {
    agrupando: {
      handler: function() {
          this.msgGrupo = null
      }
    }
  },
  computed: {
    textoBotao(){
      if(this.etapa == 1 && this.enderecoPreenchidoValido || this.enderecoValido) return 'Solicitar ordem';
      else if(this.etapa == 1) return 'Informe seu endereço para prosseguir';
      return 'Continuar';
    },
    cadastroValido() {
      var valido = true
      Object.entries(this.campos).some( item => {
        if(typeof item[1] === 'object' && Object.keys(item[1]).includes('error')){
          if(item[1].required && !item[1].value) {
            valido = false
          }
        }
      } )
      if(!this.enderecoValido && !this.enderecoPreenchidoValido) return false
      return valido
    },
    enderecoValido() {
      return this.dentista.cep &&
        this.dentista.estado &&
        this.dentista.cidade &&
        this.dentista.logradouro &&
        this.dentista.numero
        ? true
        : false;
    },
    enderecoPreenchidoValido() {
      return this.campos.cep.value &&
        this.campos.estado.value &&
        this.campos.cidade.value &&
        this.campos.logradouro.value &&
        this.campos.numero.value
        ? true
        : false;
    },
  },
  methods: {
    processFiles: function(event) {
      var files = event?.target?.files;
 
      if(files && files.length > 0) {
        this.filesArray = files;
      }
 
    },
    selecionarDente: function (dente) {
      // Seleciona diretamente um dente como um procedimento
      const fonte = this.agrupando ? this.grupoTMP : this.campos.dente.value
      let selecionados = fonte.map((item) => {
        return item.numero;
      });
      if (selecionados.includes(dente)) {
        // Já está selecionado, remover.
        var index = selecionados.indexOf(dente);
        fonte.splice(index, 1);
      } else {
        // Adicionar o dente:
        let modelo = helpers.copyJson(this.campos.dente.modelo);
        modelo.numero = dente;
        fonte.push(modelo);
      }
    },
    agruparDentes(){
      this.msgGrupo = null
      if (this.grupoTMP.length < 2) {
        //this.msgGrupo = 'Selecione pelo menos dois dentes para agrupar'
        //return false
      }
      // Agrupa os dentes que estavam selecionados
      this.campos.dente.value.unshift(helpers.copyJson(this.grupoTMP))
      this.grupoTMP = []
      //this.agrupando = false
    },
    denteSelecionado(dente) {
      // Verifica se um dente está selecionado
      const fonte = this.agrupando ? this.grupoTMP : this.campos.dente.value
      return fonte.map(item => { return item.numero }).includes(dente)
    },
    denteAgrupado(dente) {
      // Verifica se um dente é agrupado e dá pra ele a classe com seu número do grupo.
      var num = 0
      var minhaClasse = null
      this.campos.dente.value.some(d => {
        if(Array.isArray(d)){
          // Se for um array de dentes
          d.forEach(sd => {
            // Verificar cada filho
            if(sd.numero === dente) {
              minhaClasse = 'selecionado borda-'+ (num % 5) // o número, num intervalo de 0 a 5, 6 = 0, 7 = 1, etc...
              return true
            }
          })
        }
        num++
      })
      return minhaClasse
    },
    excluirDente(dente,idx) {
      if (Array.isArray(dente)) {
        dente = dente[0]
      }
      if(!dente.excluindo){
        const max = this.tempoParaIgnorarExcluirDente
        dente.tempoExclusao = max
        dente.timer = setInterval(() => {
          dente.tempoExclusao--
          if(dente.tempoExclusao <= 0){
            clearInterval(dente.timer)
            dente.excluindo = false
          }
        },1000)
        dente.excluindo = true
      } else {
        if(dente.timer) clearInterval(dente.timer)
        this.campos.dente.value.splice(idx,1)
      }
    },
    nomeGrupo(grupo) {
      // Cria um nome para o grupo baseado em seus dentes
      if(!grupo) return ''
      let label = 'Dente';
      if(grupo.length > 1) label + 's';
      let nome = grupo.map(item => { return item.numero })
      let last = nome.length > 1 ? nome.pop() : ''
      return label + ' ' + nome.join(', ') + (last ? ' e ' + last : '')
    },
    idGrupo(grupo) {
      // Cria um ID único para o grupo, a não ser que tenha outro grupo igual
      if(!grupo) return ''
      let id = grupo.map(item => { return item.numero })
      return id.join('-')
    },
    salvar: function () {

      this.loading = true;
      setTimeout(function(){
        alert('DEMONSTRAÇÃO: Sua solicitação será salva como sucesso!!!');
        this.loading = false;
      }, 2000)

    },
  },
  mounted: function () {

    var user = storage.get("user");
    this.campos.idDentista.value = 0
    this.campos.dr.value = user.nomeResponsavel

    this.laboratorio = {
        nomeResponsavel: user.nomeResponsavel,
        croResponsavel: user.croResponsavel,
        razaoSocial: user.razaoSocial
    }

    params.params(user.id).then(res => {
        this.campos.dente.modelo.procedimento.opcoes = res.procedimentos
        this.campos.dente.modelo.material.opcoes = res.materiais
    });

  },
  data() {
    return {
      loading: false,
      etapa: 0,
      laboratorio: {},
      dentista: {},
      solicitacao: {
        finalizada: false,
        idSolicitacao: null
      },
      tempoParaIgnorarExcluirDente: 3,
      laboratorios: [],
      filesArray: [],
      campos: helpers.copyJson(formDemoOS),
      reset: helpers.copyJson(formDemoOS),
      isProd: process.env.NODE_ENV === 'production',
      agrupando: true,
      grupoTMP: [],
      msgGrupo: null
    };
  }
};
export default solicitarOrdem;
</script>
<style lang="scss" scoped>
.dente {
  width: 35px;
  height: 45px;
  padding-top: 10px;
  border-radius: 70%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 2px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: 0.2s;
  &.selecionado{
    border-color: #000;
    transform: translate3d(0, 10%, 0);
    box-shadow: 0 -5px 3px rgba(0, 0, 0, 0.15);
  }
}
.dente:hover {
  transform: translate3d(0, 10%, 0);
}
.baixo .dente {
  border-radius: 70%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding-top: 0;
  padding-bottom: 10px;
  &.selecionado{
    transform: translate3d(0, -10%, 0);
    box-shadow: 0 5px 3px rgba(0, 0, 0, 0.15);
  }
}
.baixo .dente:hover {
  transform: translate3d(0, -10%, 0);
}
.dentesSelecionados .denteSel .nmDente {
  background: #e0e0e0;
  background: -moz-linear-gradient(top, #e0e0e0 0%, #f7f7f7 100%);
  background: -webkit-linear-gradient(top, #e0e0e0 0%, #f7f7f7 100%);
  background: linear-gradient(to bottom, #e0e0e0 0%, #f7f7f7 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0e0e0', endColorstr='#f7f7f7',GradientType=0 );

  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  width: auto;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.1rem;
  text-align: center;
  margin-bottom: 10px;
  position: relative;
  transition: 0.2s;

  .corGrupo{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 2px solid #000;
    align-self: center;
    margin-right: 5px;
  }

  .remover{
    position: absolute;
    right: 15px;
    padding: 10px;
    box-shadow: inset 0 1px 5px rgba(0,0,0,0.2);
    border-radius: 50px;
    transition: 0.2s;
    z-index: 5;
    text-align: center;

    &:active{
      box-shadow: inset 0 2px 8px rgba(0,0,0,0.2);
    }
    span{
      margin-left: 1px;
    }
  }
  &.excluindo{
    color: rgba(0,0,0,0.25);

    .remover{
      color: #000;
      background: #e9e9e9;
    }
  }
}
@media all and (max-width: 500px) {
  .dente {
    max-width: calc(12.5% - 4px);
  }
  .break {
    height: 50px;
  }
}
.listaLaboratorios .lab{
  min-width: 200px;
}
.agrupar{
  ::v-deep label{
    font-size: 1.3rem!important;
    line-height: 1.45rem;
  }
}

.borda-0{
  border-color: rgb(59, 137, 211)!important;
}
.borda-1{
  border-color: rgb(116, 189, 113)!important;
}
.borda-2{
  border-color: rgb(169, 133, 204)!important;
}
.borda-3{
  border-color: rgb(213, 214, 125)!important;
}
.borda-4{
  border-color: rgb(228, 133, 133)!important;
}
.adddente {
  text-transform: uppercase;
  font-size: 12px;
  padding: 5px 20px;
}
.msg{
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  color: rgb(206, 77, 60)
}
.files {
  padding: 40px 0;
}
.uploader input {
  display: none;
}
.uploader label {
  cursor: pointer;
  text-align: center;
  border: 2px solid #525f7f;
  border-radius: 10px;
  padding: 10px 0;
  opacity: 0.8;
}
.uploader label:hover {
  opacity: 1;
}
.uploader i {
  width: 100%;
  font-size: 42px;
}
.uploader span {
  font-size: 14px;
  text-transform: uppercase;
}
.uploader-list {
  margin: 20px 0 0 0;
}
</style>
